import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SignupUser, EditUser } from '../models/user';
import { errorlist } from '../providers/errorlist';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';
@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  areaData:any = [];
  errorlist:any = [];
  contactData:any = {};
  constructor(private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.errorlist = errorlist;

    this.spinnerService.show();
    this.auth.getarea().then((area) => {
      let response = area.json();
      if(response.replyCode == "error"){
        console.log("error with get area")
      }else{
        this.areaData = response.data;
        console.log("areaData", this.areaData);
        this.spinnerService.hide();
      }
    })
    .catch((err)=>{
      this.spinnerService.hide();
    });
  }

  contactSubmit(){
    this.spinnerService.show();
    console.log(this.contactData)
    this.auth.sendcontactus(this.contactData).then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
        this.router.navigateByUrl('/');
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/contact/contact.component.ts